import api from "@/lib/api";

export interface PostPurchaseSettlementPaypalOrderRequest {
  session: string;
}

export interface PostPurchaseSettlementPaypalOrderResponse {
  order_id: string;
}

export interface PostPurchaseSettlementPaypalApproveRequest {
  session: string;
  order_id: string;
}

export interface PostPurchaseSettlementPaypalApproveResponse {
  returnUrl: string;
}

export default {
  postPurchaseSettlementPaypalOrder(
    data: PostPurchaseSettlementPaypalOrderRequest
  ) {
    return api<
      PostPurchaseSettlementPaypalOrderRequest,
      PostPurchaseSettlementPaypalOrderResponse
    >({
      endpoint: "purchase/settlement/web-api/paypal-order",
      method: "POST",
      body: data
    });
  },
  postPurchaseSettlementPaypalApprove(
    data: PostPurchaseSettlementPaypalApproveRequest
  ) {
    return api<
      PostPurchaseSettlementPaypalApproveRequest,
      PostPurchaseSettlementPaypalApproveResponse
    >({
      endpoint: "purchase/settlement/web-api/paypal-approve",
      method: "POST",
      body: data
    });
  }
};
